import React/*, { useState }*/ from "react";
//import ReactDOM from "react-dom";
import "jodit";
//import "jodit/build/jodit.min.css";
import "jodit/es5/jodit.min.css";
import JoditEditor from "jodit-react";

import { makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

import HARDCODE from '../../business-const/HardCode/HardCode'

//import {
//  COLOR
//} from '../../business-const/Color/Color'

import {
    TextoBackground,
} from '../../business-components/Img/Img'

import {
    nomeCurtoCliente,
    nomeCurtoConjuge,
} from '../../business-rules/String/nomeCurto'



const useStyles = makeStyles(({ palette, ...theme }) => ({
    compatibilidadeReactQuill: ({ readOnly, paginaInteira, backgroundColor }) => ({
        '& .ql-indent-1': {
            paddingLeft: '3.5rem'
        },
        '& .ql-indent-2': {
            paddingLeft: '6rem'
        },
        '& .ql-indent-3': {
            paddingLeft: '9rem'
        },
        '& .ql-indent-4': {
            paddingLeft: '12rem'
        },
        '& .ql-indent-5': {
            paddingLeft: '15rem'
        },


        '& .ql-font-serif': {
            fontFamily: 'Georgia, Times New Roman, serif'
        },
        '& .ql-font-monospace': {
            fontFamily: 'Monaco, Courier New, monospace'
        },


        '& .ql-size-small': {
            fontSize: '0.75em'
        },
        '& .ql-size-large': {
            fontSize: '1.5em'
        },
        '& .ql-size-huge': {
            fontSize: '2.5em'
        },

        '& .ql-direction-rtl': {
            direction: 'rtl',
            textAlign: 'inherit'
        },
        '& .ql-align-center': {
            textAlign: 'center'
        },
        '& .ql-align-justify': {
            textAlign: 'justify'
        },
        '& .ql-align-right': {
            textAlign: 'right'
        },

        '& blockquote': {
            borderLeft: '4px solid #ccc',
            marginBottom: '5px',
            marginTop: '5px',
            paddingLeft: '16px'
        },

        '& .ql-syntax': {
            backgroundColor: '#23241f',
            color: '#f8f8f2',
            overflow: 'visible'
        },

        '& a': {
            cursor: 'pointer',
            textDecoration: 'underline',
            lineHeight: '26px',
            color: '#06c'
        },

        //'& .jodit-wysiwyg': {
        //},

        '& ul': {
            listStyle: 'inside'
        },
        '& ol': {
            listStyle: 'inside',
            listStyleType: 'number'
        },
    }),
}))

export const RichTextEditorPadrao = ({ name, content, placeholder, setFieldValue, readOnly, paginaInteira, backgroundColor,
    capa, variaveisGlobais, values, vars }) => {

    /*
    const copyStringToClipboard = function(str) {

        var el = document.createElement("textarea")
        el.value = str
        el.setAttribute("readonly", "")
        el.style = { position: "absolute", left: "-9999px" }
        document.body.appendChild(el)
        el.select()
        document.execCommand("copy")
        document.body.removeChild(el)
    }

    const facilityMergeFields = [
        "FacilityNumber",
        "FacilityName",
        "Address",
        "MapCategory",
        "Latitude",
        "Longitude",
        "ReceivingPlant",
        "TrunkLine",
        "SiteElevation"
    ]

    const inspectionMergeFields = [
        "InspectionCompleteDate",
        "InspectionEventType"
    ]

    const createOptionGroupElement = (mergeFields, optionGrouplabel) => {

        let optionGroupElement = document.createElement("optgroup")
        optionGroupElement.setAttribute("label", optionGrouplabel)

        for (let index = 0; index < mergeFields.length; index++) {

            let optionElement = document.createElement("option")
            optionElement.setAttribute("class", "merge-field-select-option")
            optionElement.setAttribute("value", mergeFields[index])
            optionElement.text = mergeFields[index]
            optionGroupElement.appendChild(optionElement)
        }

        return optionGroupElement
    }
    */

    const buttons = [
        "undo",
        "redo",
        "|",
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "superscript",
        "subscript",
        "|",
        "align",
        "|",
        "ul",
        "ol",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "link",
        "table",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",
        //"fullsize",
        "selectall",
        "print",
        "|",
        "source",
        "|",
        /*
        {
        name: "insertMergeField",
        tooltip: "Insert Merge Field",
        iconURL: "images/merge.png",
        popup: (editor, current, self, close) => {
            function onSelected(e) {
                let mergeField = e.target.value

                if (mergeField) {
                    console.log(mergeField)
                    editor.selection.insertNode(
                    editor.create.inside.fromHTML("{{" + mergeField + "}}")
                    )
                }
            }

            let divElement = editor.create.div("merge-field-popup")

            let labelElement = document.createElement("label")
            labelElement.setAttribute("class", "merge-field-label")
            labelElement.text = 'Merge field: '
            divElement.appendChild(labelElement)

            let selectElement = document.createElement("select")
            selectElement.setAttribute("class", "merge-field-select")
            selectElement.appendChild(createOptionGroupElement(facilityMergeFields, "Facility"))
            selectElement.appendChild(createOptionGroupElement(inspectionMergeFields, "Inspection"))
            selectElement.onchange = onSelected;
            divElement.appendChild(selectElement)

            //console.log(divElement)
            return divElement
        }
        },
        {
            name: "copyContent",
            tooltip: "Copy HTML to Clipboard",
            iconURL: "images/copy.png",
            exec: function(editor) {
                let html = editor.value
                copyStringToClipboard(html)
            }
        }
        */
    ]

    const editorConfig = {
        readonly: false,
        placeholder: placeholder ? placeholder : '',
        toolbar: true,
        spellcheck: true,
        language: "pt_br",//"en",
        toolbarButtonSize: "medium",
        toolbarAdaptive: false,
        showCharsCounter: false/*true*/,
        showWordsCounter: false/*true*/,
        showXPathInStatusbar: false,
        askBeforePasteHTML: false,//true, // resolver o problema de não funcionar o ctrl-v
        askBeforePasteFromWord: true,
        //defaultActionOnPaste: "insert_clear_html",
        buttons: buttons,
        uploader: {
        insertImageAsBase64URI: true
        },
        //width: 800,
        //height: 842,
        //controls: {
        //    font: {
        //        list: {
        //            'Poppins': 'Poppins'
        //        }
        //    },
        /*
            fontExtra: {
                name: 'fontExtra',
                //iconURL: 'https://example.com/font-weight-icon.png',
                list: {
                    'Roboto-Condensed': 'Normal',
                    'Roboto-Medium': 'Negrito',
                },
                exec: function(editor, a, b) {
                    console.log(a)
                    console.log(b.control.name)
                    //editor.execCommand('formatBlock', false, 'p');
                    editor.selection.restore()
                    editor.selection.wrapInTag('span', '', {
                    //class: b.control.name
                    style: 'background-color: yellow; padding: 10px;'
                    });
                }
            }
        */
        //}
    };

    //const initialContent = ''

    //const [data, setData] = useState(initialContent);

    const classes = useStyles({readOnly, paginaInteira, backgroundColor})

    const posIniImagem =
        paginaInteira
            ?
                content ? content.indexOf('<img src="') + 10 : 0
            :
                0

    const posFimImagem =
        paginaInteira
            ?
                content ? content.indexOf('"', posIniImagem) : 0
            :
                ''


    const imagem =
        paginaInteira
            ?
                content ? content.substring(posIniImagem, posFimImagem) : ''
            :
                ''

    return (
        <div
            //className="App"
            className={clsx(classes.compatibilidadeReactQuill, 'text-16')}
            style={
                {
                    //maxWidth: editorConfig.width,
                    //margin: "0 auto",
                    //minWidth: paginaInteira ? 825 : 0,
                    //minHeight: readOnly ? 0 : 200,
                    //maxHeight: paginaInteira ? 1730 : 960,
                    background: backgroundColor ? backgroundColor : '',//COLOR().bgContainerRichTextEditor,
                }
            }
        >
            {readOnly
                ?
                    paginaInteira
                        ?
                            <div
                                className={"ml--10 " + (capa ? "mt--7" : "mt--2")}
                            >
                                <img
                                    width="816px"//"794px"
                                    height={values.formatoReport === HARDCODE.idFormatoReportImpressao ? "1157px" : "1154px"}//{capa ? "1152px" : "1130px"}
                                    src={imagem}
                                    alt={''}
                                />
                                {capa && (
                                    <div
                                        className="mt--285"
                                        style={{
                                            width: "816px"//"794px"
                                        }}
                                    >
                                        <TextoBackground
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            vars={vars}
                                            nomeCurtoCliente={nomeCurtoCliente(values)}
                                            nomeCurtoConjuge={nomeCurtoConjuge(values)}
                                        />
                                    </div>
                                )}
                            </div>
                        :
                            <div
                                dangerouslySetInnerHTML={
                                    { __html: content ? content.replaceAll('border-color:', 'border: 1px solid; border-color:') : content}
                                }
                            />
                :
                    <JoditEditor
                        //className='p-1'
                        value={content/*data*/}
                        config={editorConfig}
                        onBlur={(value) => setFieldValue(name, value)}
                        //askBeforePasteFromWord={true}
                        //processPasteFromWord={true}
                        //defaultActionOnPasteFromWord={'insert_clear_html'}
                    />
            }
        </div>
    )
}